import { themeUi } from '../../themeUi/themeUi';

export const downloadCenter = {
  downloadCenter: {
    linksContainer: {
      backgroundColor: themeUi.semantic.color.background.secondary100
    }
  },

  components: {
    downloadCard: {
      container: {
        rlecBackgroundColor: themeUi.semantic.color.background.primary600,
        notRlecBackgroundColor: themeUi.semantic.color.background.primary500,
        color: themeUi.semantic.color.text.secondary50
      },
      selectTrigger: {
        borderColor: themeUi.semantic.color.border.primary300,
        color: themeUi.semantic.color.text.secondary50,
        fill: themeUi.semantic.color.icon.secondary50
      },
      styledButton: {
        color: themeUi.semantic.color.text.secondary50
      }
    },

    links: {
      color: themeUi.semantic.color.text.secondary950
    }
  }
};
